import type {
  WUserView,
  WResetPasswordView,
  WSiftVerificationView,
  WSiftResendConfirmationView,
} from '@zola/svc-web-api-ts-client';
import {
  LoginRequest,
  LoginResult,
  SignupRequest,
  sendLoginRequest,
  sendSignupRequest,
  sendFacebookLoginRequest,
  sendAppleLoginRequest,
  sendResetPassword as sendResetPasswordRequest,
  send2FAResendRequest,
  send2FAVerifyRequest,
  send2FAVerifyActionRequest,
  send2FAResendActionRequest,
} from '@zola-helpers/client/dist/es/redux/auth/authActions';

export const login = (loginFormRequest: LoginRequest): Promise<LoginResult> =>
  sendLoginRequest(loginFormRequest);

export const appleLogin = (appleLoginRequest: Record<string, unknown>): Promise<LoginResult> =>
  sendAppleLoginRequest(appleLoginRequest);

export const facebookLogin = (fbLoginRequest: Record<string, unknown>): Promise<LoginResult> =>
  sendFacebookLoginRequest(fbLoginRequest);

export const signup = (createUserRequest: SignupRequest): Promise<WUserView> =>
  sendSignupRequest(createUserRequest);

export const sendResetPassword = (email: string): Promise<WResetPasswordView> =>
  sendResetPasswordRequest(email);

export const resend2FA = (
  userId: string,
  sessionId: string
): Promise<WSiftResendConfirmationView> => send2FAResendRequest({ userId, sessionId });

export const verify2FA = (
  code: string,
  userId: string,
  sessionId: string
): Promise<WSiftVerificationView> => send2FAVerifyRequest({ code, userId, sessionId });

export const resendAction2FA = (): Promise<WSiftResendConfirmationView> =>
  send2FAResendActionRequest();

export const verifyAction2FA = (code: string): Promise<WSiftVerificationView> =>
  send2FAVerifyActionRequest({ code });
